// extracted by mini-css-extract-plugin
export default {"topNavButtonBase":"styles_topNavButtonBase__z7N1o","languageSwitcherButton":"styles_languageSwitcherButton__FCs0e"};